import React from 'react';

import searchCaseInsensitive from '../../../utils/searchCaseInsensitive';
import { translate } from '../../../i18n/I18nProvider';
import { formatDateForSchedule } from '../../../utils/formatDate';
import Optional from '../../../utils/optional';
import { customSearchByProduct } from '../actions/customSearchActions';
import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';
import { isArray } from '../../../utils/isDefined';
import AccountCell from './AccountCell';
import ProductCell from './ProductCell';
import ActionButtons from './ActionButtons';

export default function tableColumns({
  lang,
  selectedAccount,
  selectOptions,
  historyView = false,
  clientId
}) {
  let columns = [
    {
      render: rowData => (
        <div
          style={{
            height: '10px',
            width: '10px',
            backgroundColor:
              rowData.status === 'ACTIVE'
                ? 'green'
                : rowData.status === 'HISTORY'
                ? 'red'
                : rowData.status === 'SCHEDULED'
                ? 'yellow'
                : 'grey',
            borderRadius: '5px'
          }}
        ></div>
      ),
      hidden: historyView ? false : true,
      sorting: false,
      filtering: false,
      width: '40px',
      onHistoryView: true
    },
    {
      title: '',
      render: rowData => (
        <ActionButtons subscription={rowData} clientId={clientId} />
      ),
      disableClick: true,
      width: '40px',
      align: 'center'
    },
    {
      title: translate('TABLE.NAME'),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.name, term);
      },
      field: 'name'
    },
    {
      title: translate('ACCOUNT'),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.name, term);
      },
      field: 'accountName',
      hideColumn: true,
      render: rowData => <AccountCell data={rowData} />
    },
    {
      title: capitaliseFirstLetter(translate('SUBSCRIPTIONS.GROUP_BY_SKU')),
      field: 'skuTranslations',
      customFilterAndSearch: (term, rowData) => {
        return customSearchByProduct({ rowData, term, lang });
      },
      render: rowData => <ProductCell rowData={rowData} lang={lang} />,
      onHistoryView: true
    },
    {
      title: translate('STATUS'),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.status, term);
      },
      field: 'status',
      width: !historyView ? '50px' : 'unset',
      onHistoryView: true
    },
    {
      title: translate('ACTIVATION_DATE'),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.activationDate, term);
      },
      render: rowData => {
        return Optional(formatDateForSchedule(rowData.activationDate)).or('-');
      },
      field: 'activationDate',
      align: 'right',
      width: !historyView ? '80px' : 'unset',
      onHistoryView: true
    },
    {
      title: translate('EXPIRE_DATE'),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(
          historyView ? rowData.expiryDate : rowData.subExpireDate,
          term
        );
      },
      render: rowData => {
        return Optional(
          formatDateForSchedule(
            historyView ? rowData.expiryDate : rowData.subExpireDate
          )
        ).or('-');
      },
      field: historyView ? 'expiryDate' : 'subExpireDate',
      align: 'right',
      width: !historyView ? '80px' : 'unset',
      onHistoryView: true
    },
    {
      title: translate('QUANTITY'),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.quantity, term);
      },
      field: 'quantity',
      align: 'right',
      width: '20px'
    },
    {
      title: translate('EDIT.USER'),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.description, term);
      },
      field: 'user'
    }
  ];

  let filteredColumns = [...columns];

  if (
    selectedAccount?.type !== 'CUSTOMER' ||
    (isArray(selectOptions) && selectOptions.length === 1)
  ) {
    filteredColumns = filteredColumns.filter(column => !column.hideColumn);
  }

  if (historyView === true) {
    filteredColumns = filteredColumns.filter(
      column => column.onHistoryView === true
    );
  }

  return filteredColumns.map((column, i) => {
    return { ...column, id: i };
  });
}
